// Frontend service for the Logiwa LTL integration. Mirrors the patterns in
// outboundTruckService.js: vanilla fetch, JWT from localStorage, JSON in/out, throw on non-2xx.

const API_URL = process.env.REACT_APP_API_URL || '/api';

function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

async function parseOrThrow(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(data.message || `Request failed (${response.status})`);
    err.status = response.status;
    err.body = data;
    throw err;
  }
  return data;
}

/**
 * Look up the Logiwa shipment order matching this truck's order_number.
 * Returns { enabled, found, identifier?, totalShippingCost?, currentCarrierCurrencyCode? }.
 */
export async function lookupLogiwaOrder(truckId, orderNumber) {
  const response = await fetch(`${API_URL}/outbound-trucks/${truckId}/logiwa-lookup`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ order_number: orderNumber }),
  });
  return parseOrThrow(response);
}

/**
 * Retry the failed Logiwa push for a truck. `call` is one of "update", "document", "ship", "all".
 */
export async function retryLogiwaPush(truckId, call = 'all') {
  const response = await fetch(`${API_URL}/outbound-trucks/${truckId}/retry-logiwa-push`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ call }),
  });
  return parseOrThrow(response);
}

/**
 * Fetch the Logiwa join-row state for a truck (for HistoryView badge + record modal).
 * Returns { link: { ... } | null }.
 */
export async function getLogiwaLink(truckId) {
  const response = await fetch(`${API_URL}/outbound-trucks/${truckId}/logiwa-link`, {
    method: 'GET',
    headers: authHeaders(),
  });
  return parseOrThrow(response);
}

const logiwaOrderService = {
  lookupLogiwaOrder,
  retryLogiwaPush,
  getLogiwaLink,
};

export default logiwaOrderService;
